import { tv } from 'tailwind-variants';

// Spinner.styles.tsx
const spinnerStyles = tv({
    slots: {
        base: `
      iris:inline-flex
      iris:items-center
      iris:justify-center
    `,
        trackDark: "",
        trackLight: "",
        track: "",
        spinnerArc: "",
        standardMotionArc: `
      iris:motion-safe:block 
      iris:motion-reduce:hidden
    `,
        reducedMotionArc: `
      iris:motion-safe:hidden 
      iris:motion-reduce:block
    `,
    },
    variants: {
        size: {
            sm: {
                base: "iris:size-(--comp-size-box-spinner-sm)",
            },
            md: {
                base: "iris:size-(--comp-size-box-spinner-md)",
            },
            lg: {
                base: "iris:size-(--comp-size-box-spinner-lg)",
            },
            xl: {
                base: "iris:size-(--comp-size-box-spinner-xl)",
            },
        },
        // Responsive size variants
        smSize: {
            sm: {
                base: "iris:sm:size-(--comp-size-box-spinner-sm)",
            },
            md: {
                base: "iris:sm:size-(--comp-size-box-spinner-md)",
            },
            lg: {
                base: "iris:sm:size-(--comp-size-box-spinner-lg)",
            },
            xl: {
                base: "iris:sm:size-(--comp-size-box-spinner-xl)",
            },
        },
        mdSize: {
            sm: {
                base: "iris:md:size-(--comp-size-box-spinner-sm)",
            },
            md: {
                base: "iris:md:size-(--comp-size-box-spinner-md)",
            },
            lg: {
                base: "iris:md:size-(--comp-size-box-spinner-lg)",
            },
            xl: {
                base: "iris:md:size-(--comp-size-box-spinner-xl)",
            },
        },
        lgSize: {
            sm: {
                base: "iris:lg:size-(--comp-size-box-spinner-sm)",
            },
            md: {
                base: "iris:lg:size-(--comp-size-box-spinner-md)",
            },
            lg: {
                base: "iris:lg:size-(--comp-size-box-spinner-lg)",
            },
            xl: {
                base: "iris:lg:size-(--comp-size-box-spinner-xl)",
            },
        },
        inverse: {
            true: {
                trackDark: "iris:stroke-(--comp-color-background-spinner-dark)",
                trackLight: "iris:stroke-(--comp-color-background-spinner-light)",
                spinnerArc: "iris:stroke-(--comp-color-content-spinner-arc-inverse)",
            },
            false: {
                trackDark: "iris:stroke-(--comp-color-background-spinner-dark)",
                trackLight: "iris:stroke-(--comp-color-background-spinner-light)",
                spinnerArc: "iris:stroke-(--comp-color-content-spinner-arc)",
            },
        },
    },
    defaultVariants: {
        size: "md",
        inverse: false,
    },
});

export { spinnerStyles as default };
